import {
  API_ENDPOINT,
  useClientApiV1AuthPhoneVerificationPublicCreateMutation,
} from '../../resources/@types/accountSchema';

function useClientAuthPhoneVerificationPublicCreateMutation(
  options?: Parameters<
    typeof useClientApiV1AuthPhoneVerificationPublicCreateMutation
  >[0]['options'],
) {
  return useClientApiV1AuthPhoneVerificationPublicCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_AUTH_PHONE_VERIFICATION_PUBLIC,
    options,
  });
}

export default useClientAuthPhoneVerificationPublicCreateMutation;
